// extracted by mini-css-extract-plugin
export default {"root":"WS1bN","small":"_37TSf","normal":"_2Pkc2"};